import { render, staticRenderFns } from "./VariantEdit.vue?vue&type=template&id=5c8b447b&scoped=true&"
import script from "./VariantEdit.vue?vue&type=script&lang=js&"
export * from "./VariantEdit.vue?vue&type=script&lang=js&"
import style0 from "./VariantEdit.vue?vue&type=style&index=0&id=5c8b447b&lang=scss&scoped=true&"
import style1 from "./VariantEdit.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8b447b",
  null
  
)

export default component.exports